import VRMessage from "./message/VRMessage";

const {Semaphore} = require('async-mutex');

class VRMessageController {
    messageQueue;
    running;
    messages;
    maxMessages;
    currentY;
    maxHeightLimit;
    spacing;
    initialYPosNonVR;
    initialYPosVR;
    initialZPos;
    allowedPosition;
    initialYPosForVrMessage;
    messageQueueLock;


    constructor() {
        this.messageQueue = [];
        this.running = false;
        this.messages = [];
        this.maxMessages = 4;
        this.currentY = this.getInitialYPosForVRMessage();
        this.maxHeightLimit = 0;
        this.initialYPosForVrMessage = -1.3;
        this.spacing = 0.01;
        this.initialYPosNonVR = -1.2;
        this.initialYPosVR = -2.0;
        this.initialZPos = -4;
        this.allowedPosition = {yPosition: this.initialYPosForVrMessage, maxHeight: this.maxHeightLimit};
        this.messageQueueLock = new Semaphore(1);

    }

    addMessage(properties) {
        if (!properties.messageId) {
            properties.messageId = generateUUID();
        }

        this.messageQueue.push({properties});
        this.processMessageQueue();
        return properties;
    }

    getMessages() {
        return this.messages;
    }

    processMessageQueue() {
        this.messageQueueLock.runExclusive(async () => {
            if (this.messageQueue.length > 0) {
                const {properties} = this.messageQueue.shift();

                await this.processMessage(properties);
                this.processMessageQueue();
            }
        });
    }

    async processMessage(properties) {
        if (!properties.priority) {
            properties.priority = VrMessagePriorityEnum.HIGHPRIORITYINFO;
        }

        if (!this.checkTextPriorityForEdgeBrowser(properties) || !properties.text) {
            return;
        }
        properties.spacing = this.spacing;
        await this.createMessage(properties);
    }

    async createMessage(properties) {
        let vrMessage = this.createMessageObject(properties);
        const position = await this.allocatePosition(vrMessage.getMessageHeight());
        vrMessage.setPosition(position);
        vrMessage.show();
        this.messages.push(vrMessage);
        setTimeout(() => {
            this.removeMessage(vrMessage);
        }, vrMessage.duration || 5000);
    }

    createMessageObject(properties) {
        return new VRMessage(properties);
    }

    removeMessage(VRMessage, fadeOut = true) {
        if (!VRMessage) {
            return;
        }

        let messageIndex;

        for (let index = 0; index < this.messages.length; index++) {
            if (VRMessage.messageId === this.messages[index].messageId) {
                messageIndex = index;
                break;
            }
        }
        VRMessage = this.messages[messageIndex];

        if (!VRMessage) {
            return;
        }

        this.deallocatePosition(VRMessage.position, messageIndex);
        this.removeMessageFromList(VRMessage.messageId);
        fadeOut ? VRMessage.disposeMessage() : VRMessage.disposeMessageWithoutFadeOut();
    }

    checkTextPriorityForEdgeBrowser(props) {
        if (getBrowser() === BrowserNameEnum.EDGE) {
            return props.priority !== undefined && props.priority === VrMessagePriorityEnum.ERROR
                || props.priority === VrMessagePriorityEnum.HIGHPRIORITYINFO;
        } else return true;
    }

    getSpacing() {
        return this.spacing * getFovScaleFactor();
    }

    removeMessageFromList(messageId) {
        let self = this;

        for (let index = 0; index < self.messages.length; index++) {
            if (self.messages[index].messageId === messageId) {
                self.messages.splice(index, 1);
                break;
            }
        }

        if (!this.messages.length) {
            this.allowedPosition.yPosition = this.initialYPosForVrMessage;
        }
    }

    removeAllMessage(fadeOut = true) {
        while (this.messages.length) {
            const message = this.messages[this.messages.length - 1];
            this.removeMessage(message, fadeOut);
        }

        if (!this.messages.length) {
            this.allowedPosition.yPosition = this.initialYPosForVrMessage;
        }
    }

    async allocatePosition(msgHeight) {
        if (this.allowedPosition.yPosition + msgHeight + this.getSpacing() > this.allowedPosition.maxHeight) {
            this.removeOlderMessageToAllocate(msgHeight);
        }

        this.updateAllowedPosition(msgHeight);
        return {
            xPosition: 0,
            yPosition: this.allowedPosition.yPosition,
            zPosition: this.initialZPos
        };
    }

    removeOlderMessageToAllocate(msgHeight) {
        let yPosition = this.allowedPosition.yPosition + msgHeight + this.getSpacing();
        while (yPosition > this.allowedPosition.maxHeight) {
            const lastMessage = this.messages[0];
            if (!lastMessage) {
                break;
            }

            yPosition -= lastMessage.getMessageHeight() + this.getSpacing();
            this.removeMessage(lastMessage);
        }
    }

    updateAllowedPosition(msgHeight) {
        let lastMsgHeight = 0;
        if (this.messages.length) {
            lastMsgHeight = this.messages[this.messages.length - 1].getMessageHeight();
        }

        this.allowedPosition.yPosition += (msgHeight + lastMsgHeight) / 2 + this.getSpacing();
    }


    deallocatePosition(position, messageIndex) {
        if (!this.messages[messageIndex]) {
            return;
        }

        const height = this.messages[messageIndex].getMessageHeight();
        let prevMessageHeight = 0;
        if (this.messages.length > 1 && messageIndex === this.messages.length - 1) {
            prevMessageHeight = this.messages[this.messages.length - 2].getMessageHeight();
            this.allowedPosition.yPosition -= (height + prevMessageHeight) / 2 + this.getSpacing();
        } else {
            this.allowedPosition.yPosition -= height + this.getSpacing();
        }

        for (const message of this.messages) {
            if (message.position.yPosition > position.yPosition) {
                message.position.yPosition -= height + this.getSpacing();
                message.updatePositionY();
            }
        }
    }

    getInitialYPosForVRMessage() {
        return isVRModeEnabled() ? this.initialYPosVR : this.initialYPosNonVR;
    }

    adjustFOVChange() {
        this.messages.forEach((message) => {
            message.adjustFovChange();
        });
    }

}


export default VRMessageController;
